import { useState, useEffect } from 'react';
import { AiOutlineQrcode, AiOutlineLink } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { download, swalAlert, debug } from '../../../utils';
import API from '../../../api';
import InputAutocomplete from '../../helpers/InputAutocomplete/InputAutocomplete';
import Picture from '../../helpers/Picture/Picture';

const QRCodeGenerator = () => {
  const config = useSelector((state) => state.config);




  const [references, setReferences] = useState([]);
  const [qrCodeString, setQrCodeString] = useState('');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [filename, setFilename] = useState('');
  const [qrCodeFetching, setQrCodeFetching] = useState(false);

  useEffect(() => {
    API.get(`/admin/references`).then(response => {
      const uniqueReferences = response.data.map(item => ({ name: item }));
      setReferences(uniqueReferences);
    }).catch(error => {
      console.log(error);
    });
  }, []);
  if (!config?.tenant?.backoffice?.home_modules.includes('qrcode_gen')) {
    return null
  }

  const handleSuggestionChange = (event) => {
    const { name, value } = event.target;
    if (name === 'qrCodeString') {
      setQrCode('');
      setQrCodeString(value);
    }
  };

  const handleSuggestionSelect = (name, value) => {
    if (name === 'qrCodeString') {
      setQrCode('');
      setQrCodeString(value.name);
      generateQrCode(value.name);
    }
  };

  const generateQrCode = async (str = '') => {
    if (qrCodeFetching) return;
    setQrCode('');
    setQrCodeUrl('')
    if (typeof str !== 'string') {
      str = qrCodeString;
    }
    if (str.trim() !== '') {
      try {
        setQrCodeFetching(true);
        const response = await API.post('/admin/product/qrcode', { string: str });
        setQrCode(response.data.filename);
        setQrCodeString(response.data.string);
        setQrCodeUrl(response.data.url);
      } catch (error) {
        console.log(error);
        swalAlert(error.response.data.error.message);
      } finally {
        setTimeout(() => setQrCodeFetching(false), 500);
      }
    }
  };

  return (
    <div className="admin-home-update position-relative">
      <h4 className="">Génération de QR-code</h4>
      <div className="content d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <InputAutocomplete
            inputClassName='form-control-sm'
            disabled={qrCodeFetching}
            readonly={false}
            suggestionsSrc={references}
            suggestionsOnFocus={true}
            name='qrCodeString'
            placeholder=''
            value={qrCodeString}
            displayKey="name"
            onChange={handleSuggestionChange}
            handleOnSuggestsChange={() => { }}
            formatSuggestion={(key, reference) => reference.name}
            onSuggestionSelect={handleSuggestionSelect}
            debug={false}
          />

        </div>
        <div style={{ opacity: '0.6' }} className="flex-grow-0">
          <AiOutlineQrcode size={25} title="Générer le QR Code" className="text-brand-primary pointer" onClick={generateQrCode} />
        </div>
      </div>
      {qrCode && (
        <div className='pt-3 position-relative'>
          <span
            className="close position-absolute fs-4 pointer"
            style={{ right: '4px', top: '4px' }}
            onClick={() => setQrCode('')}
          >
            &times;
          </span>
          <div style={{ width: '80%', 'maxWidth': '300px', 'margin': '0 auto' }}>
            <Picture src={qrCode} className='w-100 mb-2' onLoad={name => setFilename(name)} />
            <div className='d-block border py-1 text-center fs-7 '>
              <span className='pointer mx-2 decoration-on-hover' onClick={() => download(`/utils/file?path=${qrCode}`, filename)} title="Télécharger">
                <AiOutlineLink size={14} className="me-1" />
                {qrCodeString}
              </span>
              {qrCodeUrl !== '' &&
                <>
                  <span>|</span>
                  <a className='mx-2 decoration-on-hover text-gray-3' href={qrCodeUrl} target='_blank'>Afficher le lien</a>
                </>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QRCodeGenerator;
